import jwtDecode from 'jwt-decode'
import moment from 'moment'

/**
 * Set expiration token date.
 *
 * @param {string} authorization - Bearer token.
 */
export const setExpirationTokenDate = (authorization) => {
  let tokenHeaderDecode = {}
  let tokenPayloadDecode = {}
  let tokenIsValid = false
  let tokenString = ''
  try {
    tokenString = authorization.split(' ')[1]
    tokenHeaderDecode = jwtDecode(tokenString, { header: true })
    tokenPayloadDecode = jwtDecode(authorization)
    tokenIsValid = true
  } catch (error) {
    console.log('Token decode error: ', error.message)
  }

  if (tokenIsValid) {
    const { iat } = tokenPayloadDecode
    const { exp } = tokenHeaderDecode
    const issuedAt = moment.unix(iat)
    const expirationTime = moment.unix(exp)

    const timer = expirationTime.diff(issuedAt, 'seconds')
    const expirationDate = moment().unix() + timer

    localStorage.setItem('expirationTokenDate', `${expirationDate}`)
  }
}
